export const DRAWER_COMPACT_WIDTH = '375px'

/**
 * CSS variable set by Drawer on `:root` while the drawer is open in Compact mode on wide screens.
 * Consumers reserve space by reading this in their layout — typically by wrapping their main
 * column with `<Drawer.SqueezeZone>`, or manually with
 * `width: calc(100% - var(--drawer-offset, 0px))`.
 *
 * Read-only: the design system sets and clears this variable.
 */
export const DRAWER_OFFSET_CSS_VAR = '--drawer-offset'

/**
 * CSS variable read by Drawer to determine how much space to leave on the left edge when in
 * Expanded mode — typically the width of the app navigation menu.
 *
 * Consumers MUST set this (usually on `:root` or the app shell) if they want the expanded drawer
 * to avoid covering their fixed-position navigation. Defaults to 0 (drawer covers the full
 * viewport width when expanded).
 *
 * @example
 *   :root { --drawer-expanded-left-offset: 240px; }
 */
export const DRAWER_EXPANDED_LEFT_OFFSET_CSS_VAR = '--drawer-expanded-left-offset'
